import * as React from "react";
import { Redirect } from "react-router-dom";
import ModalVideo from "react-modal-video";
import { CSSTransition } from "react-transition-group";
import Modal from "react-awesome-modal";
import { toast, ToastContainer } from "react-toastify";
import withServices from "../../HOCs/withServices";
import Vimeo from "@u-wave/react-vimeo";
import { Scrollbars } from "react-custom-scrollbars";
import Steps, { Step } from "rc-steps";

import {
  createItemGen,
  currentBaseUrl,
  currentUser,
  getGeneralSmartTableData,
  isHomeScreenDisabled,
  clearSessionData,
  isBasicPreassessmentDone,
  isUserLoggedIn,
  isUserUpgraded,
  userFirstName,
  hasActiveSubscription,
} from "../../common/services";

import Loader from "react-loader";
import NavBar from "../../components/CustomNav/CustomNav.Component";
import SvgDisplay from "../../common/svgDisplay";
import StudentStory from "../../common/studentStory.Component";
import Enquiry from "../../common/enquiries.Component";
import PerceptionsTile from "../../common/perceptionsTile.Component";
import TraitTile from "../../common/traitTile.Component";
import ResponsesTile from "../../common/responsesTile.Component";
import DatePicker from "../../components/DatePicker/DatePickerComponent";
import onetoneIcon from "../../assets/images/book-icon.png";
import resourceIcon from "../../assets/images/parent-resources.png";
import CustomNav from "../../components/CustomNav/CustomNav.Component";
import CalendlyBooking from "../../components/CalendlyBooking/CalendlyBooking.Component";
import ScrollCard from "../../components/Card/Card";
import UserGuide from "../../components/UserGuide/UserGuide.Component";

import {
  FormWrapper,
  Row,
  ContentWrapper,
  ContentBody,
  ContentHeading,
  InputWrapper,
  ModalContainer,
  FeedbackP,
  InputItemsRow,
  CtaWrapper,
  FabButton,
} from "../Onboard/Common/Common.styles";

import {
  ChildrenList,
  ParentResource,
  ResourceWrapper,
} from "./ParentAssessementResult.styles";

import "./parentAssessmentResult.css";

import { tourSteps } from "./ParentHomeTour";
import Tour from "reactour";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

interface IProps {
  services?: any;
  history?: any;
}

const assessmentDone = (val) => {
  if (val === "no") {
    return false;
  } else {
    return true;
  }
};

const parentGuides = [
  {
    title: "Brilliant!",
    text: "Thank you for completing the assessment. Now for your next step.",
    buttonText: "Next Step",
  },
  {
    title: "Welcome to PLOA",
    text:
      "Thank you so much for enrolling your child to complete our assessment and to you for completing our ‘Parent Assessment’.  This gives us the opportunity to learn about your perception of your child’s learning.  The results you can begin to look at by clicking RESULTS in the menu bar.",
    buttonText: "I got it",
  },
  {
    title: "Adding Your Child",
    text:
      "Please add your child or children (depending on how many you would like to take the assessment).  Currently, you have purchased one assessment for one child. \n \n You can do this by clicking “ADD CHILD” on the widget on the top right.",
    buttonText: "Perfect",
  },
  {
    title: "Completing Your Child's Assessment",
    text:
      "Adding your child involves inputting their e-mail address, once done they will receive an e-mail on how to login and complete their assessment. \nWe advise leaving your child alone to do the assessment (unless they need help answering the questions) and trying your best not to frame their response.",
    buttonText: "I understand",
  },
  {
    title: "Reviewing The Results",
    text:
      "Once your child has completed the assessment you will be able to see their results by clicking on the navigation bar at the top (click Children) and then clicking on your childs initials (on the left hand side).",
    buttonText: "I got it",
  },
  {
    title: "Understanding The Results",
    text:
      "If you need any help in understanding the results, please feel to book in a call with us to discuss the options on how best to do this, for you.  You can do this by scheduling a call in the Book A Call option.",
    buttonText: "Thank you",
  },
  {
    title: "We Are Here To Help",
    text:
      "We are here to help so please get in touch if you have any questions at all.  Finally, when you get a chance, please update your profile (top right-hand corner, click PROFILE).",
    buttonText: "Happy 'PLOAing'",
  },
];

class ParentAssessmentResultPage extends React.Component<IProps> {
  public state = {
    toLogin: false,
    toUpgradedHome: false,
    toDataCenter: false,
    toProfile: false,
    toPreassessment: false,
    children: [] as any[],
    responsekeys: {
      id: "id",
      info: "assessment_info",
      results: "results",
    },
    assessmentinfo: {} as any,
    loaded: false,
    // add child fields
    fname: "",
    lname: "",
    studentEmail: "",
    dob: "",
    signupSuccess: false,
    feedbackOpen: false,
    dateObj: null,
    registerModalOpen: false,
    assessmentAvailable: false,
    assessmentID: null,
    assessModalOpen: false,
    calendlyModalOpen: false,
    parentGuidesRead: true,
    guidesRead: true,
  };

  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.toDataCenter = this.toDataCenter.bind(this);
    this.handleAssessmentInfoLoaded = this.handleAssessmentInfoLoaded.bind(
      this
    );
    this.handleAssessmentResultsLoaded = this.handleAssessmentResultsLoaded.bind(
      this
    );
    this.addChild = this.addChild.bind(this);
    this.fetchChildredInfo = this.fetchChildredInfo.bind(this);
  }

  public async componentDidMount() {
    // if (isHomeScreenDisabled()) {
    //   clearSessionData();
    //   // this.setState({ tologin: true });
    // }
    // fetch data as appropriate
    if (!isUserLoggedIn()) {
      this.setState({ toLogin: true });
    } else if (!hasActiveSubscription()) {
      this.props.history.replace(currentBaseUrl() + "purchase");
    } else {
      getGeneralSmartTableData(
        "admin/assessments/get_user_preassessment_details/",
        (responsetext) => this.handleAssessmentInfoLoaded(responsetext)
      );

      this.fetchChildredInfo();
      const assessmentRes = await this.props.services.adminAPI.getNextAssessment();
      // // console.log("ASSiNFO: " + JSON.stringify(assessmentRes, null, 2));
      if (assessmentRes.ok) {
        const assessmentInfo = assessmentRes.data;
        if (assessmentInfo.status === "available") {
          this.setState({
            assessmentAvailable: true,
            assessmentID: assessmentInfo.assessment_id,
            assessModalOpen: true,
          });
        } else {
          this.setState({ assessmentAvailable: false });
        }
      }
    }
  }

  public handleAssessmentInfoLoaded(res) {
    // response payload contains assessment id
    // assessment id used to fetch the full assessment data
    if (res.code === 200) {
      // console.log("ParentAssessmentInfo: " + JSON.stringify(res, null, 4));
      getGeneralSmartTableData(
        "admin/assessments/" +
          res.response[this.state.responsekeys.id] +
          "/completed_assessment/",
        (responsetext) => this.handleAssessmentResultsLoaded(responsetext)
      );
    } else if (res.code === 401) {
      // console.log("No Auth");
    }
  }

  public handleAssessmentResultsLoaded(res) {
    if (res.code === 200) {
      // console.log("ParentAssessmentResults: " + JSON.stringify(res, null, 4));
      this.setState({ assessmentinfo: res.response, loaded: true });
    } else if (res.code === 401) {
      // console.log("NO auth");
      this.setState({ toLogin: true });
    }
  }

  public async fetchChildredInfo() {
    const {
      services: { parentsAPI, currentUserID },
    } = this.props;
    const childrenRes = await parentsAPI.getChildren(currentUserID);
    const tourStatus = localStorage.getItem(
      `${this.props.services.currentUsername}ParentHomeTour`
    );

    let guidesRead = true;
    if (tourStatus === null) {
      guidesRead = false;
    }
    if (childrenRes.ok) {
      // console.log(childrenRes.data);
      this.setState({ children: childrenRes.data.children, guidesRead });
    }
  }

  public startAssessment = () => {
    const { assessmentID, assessmentAvailable } = this.state;
    if (assessmentAvailable) {
      this.props.history.push(`${currentBaseUrl()}assessment/${assessmentID}`);
    } else {
      return;
    }
  };

  public onLogout() {
    this.setState({ toLogin: true });
  }
  public onProfile = () => {
    this.props.history.push(`${currentBaseUrl()}profilepage`);
  };
  public openChildResults(childID) {
    this.props.history.push(`${currentBaseUrl()}datacenter/${childID}`);
  }

  public closeTour = () => {
    localStorage.setItem(
      `${this.props.services.currentUsername}ParentHomeTour`,
      "true"
    );
    this.setState({ guidesRead: true });
  };

  public disableBody = (target) => {
    disableBodyScroll(target);
  };
  public enableBody = (target) => {
    enableBodyScroll(target);
  };

  public toggleParentGuides = () => {
    // this.ls.removeItem(localStorageKey);
    // const { parentGuidesRead } = this.state;
    // this.setState({ parentGuidesRead: !parentGuidesRead });
    const { guidesRead } = this.state;
    this.setState({ guidesRead: !guidesRead });
  };

  public toDataCenter() {
    this.setState({ toDataCenter: true });
  }

  public toggleRegisterChild = () => {
    const { registerModalOpen } = this.state;
    this.setState({ registerModalOpen: !registerModalOpen });
  };
  public toggleCalendly = () => {
    const { calendlyModalOpen } = this.state;
    this.setState({ calendlyModalOpen: !calendlyModalOpen });
  };
  public closeFeedbackModal = () => {
    this.setState({ feedbackOpen: false });
  };
  public handleChange = (field, e) => {
    // console.log(field + e.target.value);
    if (field === "fname") {
      this.setState({ fname: e.target.value });
    }
    if (field === "lname") {
      this.setState({ lname: e.target.value });
    }
    // if (field === "dob") {
    //   this.setState({ dob: e.target.value });
    // }
    if (field === "email") {
      this.setState({ studentEmail: e.target.value });
    }
  };

  public ageChangeHandler = (dateObj) => {
    const dob = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
    this.setState({ dateObj, dob });
  };

  public async addChild(event) {
    event.preventDefault();
    const { fname, lname, studentEmail, dob } = this.state;
    const {
      services: { parentsAPI, currentUserID },
    } = this.props;
    const item = {
      first_name: fname,
      last_name: lname,
      email: studentEmail,
      dob,
    };
    const addChildRes = await parentsAPI.addChild(item);
    if (addChildRes.ok) {
      toast.success("Congratulations on adding your child");
      this.fetchChildredInfo();
      this.setState({
        signupSuccess: true,
        feedbackOpen: true,
        registerModalOpen: false,
      });
      setTimeout(() => this.closeFeedbackModal(), 5000);
    } else {
      toast.error(
        "You cannot add a child with the same email, this " +
          addChildRes.data.status
      );
      this.setState({ signupSuccess: false, feedbackOpen: true });
      setTimeout(() => this.closeFeedbackModal(), 5000);
    }
  }

  public renderFeedbackModal = () => {
    const { feedbackOpen, signupSuccess } = this.state;
    if (feedbackOpen) {
      let content = (
        <FeedbackP success={signupSuccess}>
          <span>Congratulations for adding your child. </span>
          <br /> Check your email for confirmation &amp; sign in details!
        </FeedbackP>
      );
      if (!signupSuccess) {
        content = (
          <FeedbackP success={signupSuccess}>
            <span>Oops, something went wrong! </span>
            <br /> check the details and try again!
            <br /> Remember, you cannot use the register multiple children{" "}
            <br /> with the same email
          </FeedbackP>
        );
      }
      return (
        <Modal
          visible={feedbackOpen}
          effect="fadeInUp"
          onClickAway={this.closeFeedbackModal}
        >
          <ModalContainer height="240px">{content}</ModalContainer>
        </Modal>
      );
    } else {
      // console.log("no feedback yet");
      return;
    }
  };

  public renderChildRegisterModal = () => {
    const { registerModalOpen, children } = this.state;
    return (
      <Modal
        visible={registerModalOpen}
        effect="fadeInUp"
        onClickAway={this.toggleRegisterChild}
        width="600"
      >
        <Row>
          <FormWrapper width="100%">
            <i
              className="fa fa-times-circle-o close-modal"
              aria-hidden="true"
              onClick={this.toggleRegisterChild}
            />

            <form onSubmit={this.addChild}>
              <h2 className="form-header">REGISTER YOUR CHILD'S DETAILS</h2>

              <div className="fields-wrapper">
                <InputWrapper>
                  <p>1. What are your child's names?</p>
                  <InputItemsRow>
                    <input
                      className="custom-textfield"
                      type="text"
                      name="firstName"
                      id="first-name"
                      placeholder="First Name"
                      // onChange={this.handleChange}
                      required={true}
                      data-arg="firstName"
                      onChange={this.handleChange.bind(this, "fname")}
                    />

                    <input
                      className="custom-textfield"
                      type="text"
                      name="lastName"
                      id="last-name"
                      placeholder="Last Name"
                      // onChange={this.handleChange}
                      required={true}
                      data-arg="lastName"
                      onChange={this.handleChange.bind(this, "lname")}
                    />
                  </InputItemsRow>
                </InputWrapper>
                <InputWrapper>
                  <p>2. What is your child's email address?</p>
                  <input
                    type="text"
                    className="custom-textfield"
                    id="studentemail"
                    placeholder="Email Address"
                    required={true}
                    data-arg="studentemail"
                    onChange={this.handleChange.bind(this, "email")}
                  />
                </InputWrapper>

                <InputWrapper>
                  <p>3. How old is your child?</p>
                  <DatePicker
                    value={this.state.dateObj}
                    onChange={this.ageChangeHandler}
                  />
                </InputWrapper>
              </div>

              <p
                className="charge-alert"
                style={{
                  font: 'italic bold 16px "Roboto Condensed"',
                  textTransform: "uppercase",
                  color: "#ff0033",
                  width: "90%",
                  textAlign: "center",
                  paddingTop: "8px",
                }}
              >
                {children.length > 0
                  ? "Your current Performance Learning subscription is for one child, if you add another child you will be charged £65.00. Payment will be taken when you click ‘Add Child’ from the card you registered to your Performance Learning account. Assessment payments will recur quarterly."
                  : ""}
              </p>

              <CtaWrapper>
                <button className="register-parent green-button" type="submit">
                  ADD CHILD
                </button>
              </CtaWrapper>
            </form>
          </FormWrapper>
        </Row>
      </Modal>
    );
  };

  public renderChildrenList = () => {
    const { children } = this.state;
    let content = (
      <React.Fragment>
        <p className="no-child">Please add your child or children here </p>
      </React.Fragment>
    );
    if (children.length > 0) {
      content = (
        <ScrollCard
          // className="hide-x children-list"
          scrollable={true}
          maxHeight={225}
          scrollJumpSize={50}
          hidePatternBg={true}
          children={children.map((child) => (
            <div
              onClick={this.openChildResults.bind(this, child.id)}
              className="child-entry"
              key={child.User}
              style={{
                backgroundColor: `${
                  assessmentDone(child.PreAssesmentDone) ? "#acff24" : "#ff0033"
                }`,
              }}
              title={`${
                assessmentDone(child.PreAssesmentDone)
                  ? "Assessment Done :-)"
                  : "Assessment Not Done!"
              }`}
            >
              <p className="child-name">
                {child.first_name === ""
                  ? `${child.User}`
                  : `${child.first_name} ${child.last_name}`}
              </p>
            </div>
          ))}
        />
      );
    }
    return (
      <ChildrenList className="step-2">
        <h2 className="label">Children</h2>
        {content}
        <button className="new-child step-3" onClick={this.toggleRegisterChild}>
          <span>
            <i className="fa fa-plus" />
            &nbsp;Add New Child
          </span>
        </button>
      </ChildrenList>
    );
  };

  public renderAssessmentInfoModal = () => {
    return (
      <Modal
        visible={this.state.assessModalOpen}
        effect="fadeInDown"
        // onClickAway={this.closeAssessmentModal}
      >
        <div className="exit-modal-container">
          <p className="exit-warning">
            Please take your assessment before we continue
          </p>

          <div className="exit-warning-buttons">
            <button className="blue-button" onClick={this.startAssessment}>
              Of course
            </button>
            {/* <button className="green-button" onClick={this.closeAssessmentModal}>I'll stay</button> */}
          </div>
        </div>
      </Modal>
    );
  };

  public renderReactTourAnchors = () => {
    return (
      <div style={{width: '100%', position: 'fixed', top: '50px' }}>
        <div className="step-5" style={{left: '50%', width: '0', position: 'relative'}} />
        <div className="step-6" style={{left: '80%', width: '0', position: 'relative'}} />
      </div>
    )
  }

  public renderCalendlyPopup = () => {
    return (
      <Modal
        visible={this.state.calendlyModalOpen}
        effect="fadeInDown"
        onClickAway={this.toggleCalendly}
      >
        <CalendlyBooking url="https://calendly.com/performance_learning/plexcall?background_color=2a2a2a&text_color=ffffff&primary_color=acff24&month=2020-06" />
      </Modal>
    );
  };
  public render() {
    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }

    if (!isUserLoggedIn) {
      return <Redirect to="/login" />;
    }

    if (this.state.toDataCenter) {
      return <Redirect to={currentBaseUrl() + "datacenter"} />;
    }

    return (
      <div>
        {/* <NavBar logoutParent={this.onLogout} profileParent={this.onProfile} /> */}
        <CustomNav
          logoutParent={this.onLogout}
          profileParent={this.onProfile}
          designation="parent"
          profileChildren={this.toDataCenter}
          {...this.props}
        />
        <Tour
          steps={tourSteps}
          isOpen={!this.state.guidesRead}
          onRequestClose={this.closeTour}
          onAfterOpen={this.disableBody}
          onBeforeClose={this.enableBody}
          accentColor="#ff0033"
        />
        <ToastContainer />
        {this.renderChildRegisterModal()}
        {this.renderFeedbackModal()}
        {this.renderAssessmentInfoModal()}
        {this.renderReactTourAnchors()}
        {/* {parentGuidesRead ? (
          ""
        ) : (
          <div className="homepage-overlay">
            <div className="overlay-content">
              <i
                className="fa fa-times-circle-o"
                onClick={this.closeParentGuides}
              />
              <h2 className="overlay-content-heading">
                {parentGuides[parentGuidesIdx].title}
              </h2>
              <p className="overlay-content-body">
                {parentGuides[parentGuidesIdx].text}
              </p>
              <button
                className="overlay-button green-button"
                onClick={this.nextStepHandler}
              >
                {parentGuides[parentGuidesIdx].buttonText}
              </button>
              <Steps current={parentGuidesIdx} size="small">
                {parentGuides.map((step, idx) => {
                  return (
                    <Step
                      key={step.title + idx}
                      onClick={this.onStepClick.bind(this, idx)}
                    />
                  );
                })}
              </Steps>
            </div>
          </div>
        )} */}
        {/* <UserGuide
          currentUser={currentUser()}
          guides={parentGuides}
          toggleGuide={this.state.parentGuidesRead}
        /> */}
        <CSSTransition in={true} appear={true} classNames="fade" timeout={800}>
          <div className="p-result-container">
            <div className="p-result-content">
              <div className="p-result-row p-row-welcome">
                <h4 className="welcome-message">
                  Welcome <span>{userFirstName()}</span>
                </h4>
              </div>

              {/* trait tiles showing assessment performance of the parent and all related users */}
              <div className="trait-tile-container">
                <div className="trait-tile-wrapper step-1">
                  <h2 className="trait-owner">
                    MY CHILD'S LEARNING STYLE ACCORDING TO ME
                  </h2>
                  <TraitTile
                    results={this.state.assessmentinfo.results}
                    vimeoModel="parents"
                  />
                </div>
                {this.renderChildrenList()}
              </div>
            </div>
            <Row width="80%" justify="flex-start">
              <ResourceWrapper
                className="step-4"
                width="23.5%"
                style={{ marginRight: "1.5%", paddingBottom: "8px" }}
              >
                <h2 className="resource-header">BOOK A CALL</h2>
                <ParentResource>
                  <div className="inner-row">
                    <img src={onetoneIcon} alt="" />
                    <p>
                      If you need help understanding the results, book a call
                      with one of our Performance Learning coaches
                    </p>
                  </div>
                  <button
                    className="green-button book-now"
                    onClick={this.toggleCalendly}
                  >
                    Book Now
                  </button>
                </ParentResource>
              </ResourceWrapper>
              <ResourceWrapper width="24%">
                <h2 className="resource-header">PIT STOP</h2>
                <ParentResource>
                  <div className="inner-row">
                    <img src={resourceIcon} alt="" />
                    <p>Launching Soon</p>
                  </div>
                </ParentResource>
              </ResourceWrapper>
            </Row>
            <Row>{this.renderCalendlyPopup()}</Row>
            {/* <Row justify="flex-end"> */}
            <FabButton bgColor="#1a1a1a" onClick={this.toggleParentGuides}>
              <p className="fab-text">Need a hand</p>
              <i
                className="fa fa-question"
                style={{ fontSize: "30px", color: "#ff0033" }}
              />
            </FabButton>
            {/* </Row> */}
          </div>
        </CSSTransition>
      </div>
    );
  }
}

export default withServices(ParentAssessmentResultPage);



// WEBPACK FOOTER //
// ./src/pages/Assessments/parentAssessmentResult.Component.tsx